import styled from 'styled-components';
import { breakpoint, font } from 'styles/globals';
import { getColor, Theme } from 'styles/theme';

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;

    @media(${breakpoint.mdMin}) {
        margin-bottom: 0;
    }
`;

export const Text = styled.p``;

export const Title = styled.p<{ theme: Theme }>`
    color: ${getColor('textSecondary')};
    font-family: ${font.graphikCond};
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; 
    letter-spacing: 0.5px;
    text-transform: uppercase;
`;
